import React, { useContext } from 'react'
import { AccountsContext } from 'AccountsContext'
import SupportBody from '../SupportBody'
import SupportHeader from '../SupportHeader'

const SupportWidget = ({ verticalName, setRefetchCases }) => {
  const {
    isModalOpen,
    classesAddedToWidgetContainer,
  } = useContext(AccountsContext)
  return (
    <React.Fragment>
      <div className={isModalOpen ? `${classesAddedToWidgetContainer} pushLeft` : 'support-widget-container'}>
        <SupportHeader verticalName={verticalName} setRefetchCases={setRefetchCases} />
        <If condition={isModalOpen}>
          <SupportBody verticalName={verticalName || 'air'} />
        </If>
      </div>
    </React.Fragment>
  )
}

export default SupportWidget
